import React, { Component } from 'react'
import SwipCat from './SwipCat'
import ModulePage from './ModulePage'
import ModuleList from './ModuleList'
import ModuleAnimation from './ModuleAnimation'
import PromoteDownload from '../UI/PromoteDownload' 
import PromoteInventory from '../UI/PromoteInventory'
// import PromoteReviews from '../UI/PromoteReviews'
// import PromoteDeposit from '../UI/PromoteDeposit'
// import './Home.css'
import tools from '../../tools'
import connexion from '../../connexion'
import Cookies from 'js-cookie'
import Skeleton from '../UI/Skeleton'

class Home extends Component {
	constructor(props) {
		super(props)
		this._enter_anim = (props.consumeNavBack && props.consumeNavBack()) ? "page-back-in" : ""
		this.state = {
			modules: null,
			showPromote: false
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Home')
		this.props.updateShell('home', false, this.props.history.location.pathname)
		this.loadModules()
		this.loadIcons()
		this.props.fetchNotifications()
	}

	_restoreScroll = () => {
		const wrapper = document.getElementById("wrapper")
		const saved = this.props.scroll_home
		if (!wrapper || !saved)
			return ;
		if (saved.bottom !== true && !(saved.top > 0))
			return ;
		//si l'utilisateur était en bas, viser le bas réel (la hauteur peut encore grandir)
		const target = (saved.bottom === true) ? wrapper.scrollHeight : saved.top
		wrapper.scroll(0, target)
		this._applied_scroll = wrapper.scrollTop
	}

	_correctScroll = () => {
		const wrapper = document.getElementById("wrapper")
		if (!wrapper)
			return ;
		//l'utilisateur a repris la main : on ne touche plus au scroll
		if (Math.abs(wrapper.scrollTop - this._applied_scroll) > 4)
			return ;
		this._restoreScroll()
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.modules === null && this.state.modules)
		{
			//restauration synchrone avant peinture, puis re-collage pendant que les modules asynchrones poussent la hauteur
			this._restoreScroll()
			this._restore_timers = [250, 600, 1200].map(delay => setTimeout(this._correctScroll, delay))
		}
		if (prevProps.user !== this.props.user)
		{
			this.loadModules()
			// setTimeout(() => {
			// 	const modules = tools.clone(this.state.modules)
			// 	modules.splice(this.state.showPromote, 1)
			// 	this.setState({ modules: modules })
			// }, 150)
		}
	}

	componentWillUnmount() {
		if (this._restore_timers)
			this._restore_timers.forEach(timer => clearTimeout(timer))
		const wrapper = document.getElementById("wrapper")
		if (wrapper)
		{
			const bottom = (wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 4)
			this.props.updateScrollHome({ top: wrapper.scrollTop, bottom: bottom })
		}
	}

	loadIcons = () => {
		if (!this.props.icons)
			this.props.fetchIcons()
	}

	loadModules = () => {
		this.props.fetchModules()
		.then(fetched => {
			//copie sans les modules injectés : fetchModules renvoie le tableau partagé du
			//cache d'App, et loadModules retourne à chaque changement d'utilisateur ;
			//sans ce filtre, chaque passage empilait une bannière de plus
			let modules = fetched.filter(module => module && module.type !== "install" && module.type !== "inventory")
			for (let i = 0; i < modules.length; i++)
			{
				if (modules[i].type === "group")
				{
					for (let j = 0; j < this.props.groups.length; j++)
					{
						if (this.props.groups[j]._id === modules[i].values.group)
						{
							modules[i].values.group = this.props.groups[j]
							break
						}
					}
				}
			}
			let pos = false
			const time = tools.getTimestamp()
			const delay_dismiss = 60 * 60 * 24
			//le refus est aussi persisté en cookie : l'état React ne survit pas au rechargement
			const promote_dismiss = this.props.user.promote_pwa || Number(Cookies.get('promote_pwa') || 0)
			//iOS n'émet jamais beforeinstallprompt : la bannière y montre un mode d'emploi
			const ios = tools.isIos(navigator.userAgent, navigator.platform, navigator.maxTouchPoints) && !tools.isStandalone()
			if ((this.props.installEvent || ios) && (!promote_dismiss || time - promote_dismiss > delay_dismiss))
			{
				//3e position, ou fin de liste s'il y a moins de 2 modules
				pos = (modules.length < 2) ? modules.length : 2
				modules.splice(pos, 0, { _id: 42, translations: null, type: "install", ios: (this.props.installEvent) ? false : true })
			}
			const stay = (this.props.user && this.props.user.stay) ? this.props.user.stay : null
			if (stay && time > stay.arrival_time && (!this.props.user.dismiss_inventory || time - this.props.dismiss_inventory > delay_dismiss))
			{
				this.props.fetchInventory(stay.stay_number, "both", stay.location_category)
				.then(inventories => {
					if (inventories !== false)
					{
						this.props.fetchConfigInventory()
						.then(config_inventory => {
							let inventory_arrival = null
							let inventory_departure = null
							for (let i = 0; i < inventories.length; i++)
							{
								if (inventories[i].type === "arrival")
									inventory_arrival = inventories[i]
								else if (inventories[i].type === "departure")
									inventory_departure = inventories[i]
							}
							const arrival_limit = stay.arrival_time + (config_inventory.delay * 60 * 60)
							const departure_limit = stay.departure_time - (config_inventory.delay * 60 * 60)
							if ((config_inventory.arrival === true && time <= arrival_limit && inventory_arrival === null) ||
								(config_inventory.departure === true && time >= departure_limit && time < stay.departure_time && inventory_departure === null))
								modules.unshift({ _id: 21, type: "inventory" })
						})
						.catch(err => {
							console.log(err)
						})
					}
				})
				.catch(err => {
					console.log(err)
				})
			}
			this.setState({ modules: modules, showPromote: pos })
		})
		.catch(err => console.log(err))
	}

	render() {
		if (!this.state.modules || !this.props.icons)
		{
			return (
				<Skeleton variant="home" />
			)
		}
		else
		{
			return (
				<div className={this._enter_anim}>
					<div className="flex justify-center items-center z-0 w-full fixed top-0 h-36"
						style={this.props.homeBanner
							? { backgroundImage: 'url(' + connexion.connect.url + 'dashboard/files/get-image/' + this.props.homeBanner + ')', backgroundSize: 'cover', backgroundPosition: 'center' }
							: { backgroundColor: '#' + this.props.theme.color1 }
						}
					>
						{!this.props.homeBanner && (
							<h1 className="text-white text-3xl mx-12 text-center">{this.props.appName}</h1>
						)}
					</div>
					<div className="z-10 w-full absolute mt-32 pt-12 rounded-3xl bg-white">
						<div className="body" onScroll={this.onScroll}>
							{this.state.modules.map(({ _id, translations, type, values, ios }) => {
								let title = ""
								let subtitle = ""
								let meta = null
								if (translations)
								{
									for (let i = 0; i < translations.length; i++)
									{
										if (translations[i].lang === this.props.user.lang)
										{
											if ((type === "page" || type === "list") && translations[i].values)
											{
												subtitle = translations[i].values.subtitle
												if (translations[i].values.meta && translations[i].values.meta.length > 0)
													meta = translations[i].values.meta
											}
											title = translations[i].title
											break
										}
									}
								}
								if (type === "install") // FRANCKY LES MODULES PROMOTES ICI
								{
									return (
										<PromoteDownload
											key={_id}
											lang_assets={this.props.lang_assets}
											btnLater= {this.props.handleInstallApp.bind(this, false)}
											btnInstall={this.props.handleInstallApp.bind(this, true)}
											ios={ios}
											id={_id}
										/>
									)
								}
								if (type === "inventory")
								{
									// return (<PromoteDeposit />)
									return (
										<PromoteInventory
											lang_assets={this.props.lang_assets}
											dismissInventory={this.props.dismissInventory}
											key={_id}
										/>
									)
								}
								else if (type === "animation")
								{
									return (
										<ModuleAnimation
											key={_id}
											lang_assets={this.props.lang_assets}
											title={title}
											user={this.props.user}
											theme={this.props.theme}
											fetchAnimationNext={this.props.fetchAnimationNext}
											fetchAnimationCategories={this.props.fetchAnimationCategories}
										/>
									)
								}
								else if (type === "group")
								{
									return (
										<SwipCat
											key={_id}
											lang_assets={this.props.lang_assets}
											title={title}
											icons={this.props.icons}
											categories={this.props.categories}
											fetchCategoriesByGroup={this.props.fetchCategoriesByGroup}
											group={values.group}
											theme={this.props.theme}
											user={this.props.user}
										/>
									)
								}
								else if (type === "page")
								{
									return (
										<ModulePage
											key={_id}
											lang_assets={this.props.lang_assets}
											title={title}
											page={values.page}
											category={values.category}
											groups={this.props.groups}
											subtitle={subtitle}
											meta={meta}
											user={this.props.user}
											fetchPageByID={this.props.fetchPageByID}
											fetchPageByCategory={this.props.fetchPageByCategory}
											fetchCategoryByID={this.props.fetchCategoryByID}
										/>
									)
								}
								else if (type === "list")
								{
									return (
										<ModuleList
											key={_id}
											lang_assets={this.props.lang_assets}
											title={title}
											list={values.list}
											category={values.category}
											groups={this.props.groups}
											subtitle={subtitle}
											meta={meta}
											user={this.props.user}
											fetchCategoryByID={this.props.fetchCategoryByID}
											fetchListByID={this.props.fetchListByID}
										/>
									)
								}
								else
									return null
							})}
						</div>
					</div>
				</div>
			)
		}
	}
}

export default Home